/*
 * @Description: 任务记录与汇总列表对应字段
 * @Date: 2020-01-06 13:23:55
 */
import createField from './tableDetailFields'; // 其中包含了列表与详情的字段
import { $$Seat } from './tool';

const map = {
  '1_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'customerName',
    'hospitalName',
    'visitTime',
    'commonFormatterVisitMinute',
    'visitAddress',
    'commonRender_U_0123_addressWatermarkPicUrl',
    'commonRender_U_1_autographPicUrl',
    'commonRender_Q_0_U_23_pics',
    'commonRender_Q_1_U_23_pics',
    'commonRender_Q_2_U_23_pics',
    'auditStatus'
  ], // 学术-记录
  '1_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 学术-汇总
  '9_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'customerName',
    'hospitalName',
    'gradeName',
    'visitTime',
    'commonFormatterVisitMinute',
    'commonRender_U_0123_addressWatermarkPicUrl',
    'commonRender_U_1_autographPicUrl',
    'commonRender_Q_0_U_23_pics',
    'commonRender_Q_1_U_23_pics',
    'commonRender_Q_2_U_23_pics',
    'auditStatus'
  ], // 等级医院拜访-记录
  '9_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 等级医院拜访-汇总
  '10_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'customerName',
    'hospitalName',
    {
      prop: 'gradeName',
      label: '医疗机构类型'
    },
    'visitTime',
    'commonFormatterVisitMinute',
    'commonRender_U_0123_addressWatermarkPicUrl',
    'commonRender_U_1_autographPicUrl',
    'commonRender_Q_0_U_23_pics',
    'commonRender_Q_1_U_23_pics',
    'commonRender_Q_2_U_23_pics',
    'auditStatus'
  ], // 基层医疗机构拜访-记录
  '10_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 基层医疗机构拜访-汇总
  '2_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    // 'assistantAlliance',
    'pharmacyName',
    'startDt',
    'addressPicUrl',
    'salesPrice',
    'displayStatus',
    'isProdectPop',
    'isKnow',
    'imgUrl$0',
    'imgUrl$1',
    'imgUrl$2',
    {
      prop: 'auditStatus',
      label: '状态'
    }
  ], // OTC拜访-记录
  '2_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // OTC拜访-汇总
  '5_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    {
      label: '问卷编号',
      prop: 'taskCode'
    },
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'createDt',
    'auditStatus'
  ], // 患者调研-记录
  '5_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 患者调研-汇总
  '3_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'hospital',
    {
      label: '会议时间',
      prop: 'createDt'
    },
    'meetingMinute',
    'messages',
    {
      label: '人员反馈',
      prop: 'customerRemark'
    },
    'longitudeAndLatitude',
    'addressPicUrl',
    'signCount',
    {
      label: '状态',
      prop: 'auditStatus'
    }
  ], // 科室会-记录
  '3_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 科室会-汇总
  '4_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'project_name',
    'finishDT',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'startdt',
    'meetingMinute',
    'visitAddress',
    'longitudeAndLatitude',
    'addressPicUrl',
    'customerFeedback',
    'signCount',
    'auditStatus'
  ], // 患教会-记录
  '4_1': [
    'index',
    'industryEnterpriseName',
    'enterprise_name',
    'supplierEnterpriseName',
    'project_name',
    'task_dt',
    'full_name',
    'phone',
    'assistantAlliance',
    'task_sum',
    'finish_sum',
    'nofinish',
    'pass',
    'passing',
    'nopass',
    'invalidCount',
    'finishRate'
  ], // 患教会-汇总
  '6_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    {
      label: '点击数',
      prop: 'finishSum'
    }
  ], // 线上推广-记录
  '6_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'uncompletedQuantity',
    {
      label: '审核通过量',
      prop: 'finishSum'
    },
    // 'invalidCount',
    'completionRate'
  ], // 线上推广-汇总
  '11_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'hospitalName',
    'hospitalAddress',
    'firstHospitalMonth',
    'jhpic1',
    'jhpic2',
    'jhpic3',
    'jypic1',
    'jypic2',
    'jypic3',
    'zlpic1',
    'zlpic2',
    'zlpic3',
    'auditStatus'
  ], // 特级三甲医院市场准入-记录
  '11_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 特级三甲医院市场准入-汇总
  '12_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'hospitalName',
    'hospitalAddress',
    'firstHospitalMonth',
    'common_U0123_jhpic1',
    'common_U0123_jhpic2',
    'common_U0123_jhpic3',
    'jypic1',
    'jypic2',
    'jypic3',
    'zlpic1',
    'zlpic2',
    'zlpic3',
    'auditStatus'
  ], // 三级医院市场准入-记录
  '12_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 三级医院市场准入-汇总
  '13_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    'hospitalName',
    'hospitalAddress',
    'firstHospitalMonth',
    'common_U0123_jhpic1',
    'common_U0123_jhpic2',
    'common_U0123_jhpic3',
    'jypic1',
    'jypic2',
    'jypic3',
    'zlpic1',
    'zlpic2',
    'zlpic3',
    'auditStatus'
  ], // 二级医院市场准入-记录
  '13_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 三级医院市场准入-汇总
  '14_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    {
      prop: 'hospitalName',
      label: '机构名称'
    },
    {
      label: '机构地址',
      prop: 'hospitalAddress'
    },
    'firstHospitalMonth',
    'common_U0123_jhpic1',
    'common_U0123_jhpic2',
    'common_U0123_jhpic3',
    'jypic1',
    'jypic2',
    'jypic3',
    'zlpic1',
    'zlpic2',
    'zlpic3',
    'auditStatus'
  ], // 基层医疗机构市场准入-记录
  '14_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 基层医疗机构市场准入-汇总
  '15_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'assistantAlliance',
    {
      label: '药店名称',
      prop: 'hospitalName'
    },
    {
      label: '药店地址',
      prop: 'hospitalAddress'
    },
    {
      label: '首次进店月份',
      prop: 'firstHospitalMonth'
    },

    'common_U0123_jhpic1',
    'common_U0123_jhpic2',
    'common_U0123_jhpic3',
    'zppic1',
    'zppic2',
    'zppic3',
    {
      use: [0, 1, 2, 3],
      label: '药店进店批准',
      prop: 'jypic1'
    },
    {
      use: [0, 1, 2, 3],
      label: '药店进店批准',
      prop: 'jypic2'
    },
    {
      use: [0, 1, 2, 3],
      label: '药店进店批准',
      prop: 'jypic3'
    },
    'zlpic1',
    'zlpic2',
    'zlpic3',
    'auditStatus'
  ], // 零售药店市场准入-记录
  '15_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 零售药店市场准入-汇总
  '7_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    {
      label: '问卷编号',
      prop: 'taskCode'
    },
    'taskDt',
    'fullName_check',
    'phone',
    'medicalAlliance',
    {
      label: '填写时间',
      prop: 'createDt'
    },
    'audit_status'
  ], // 医学调研-记录
  '7_1': [
    'index',
    'industryEnterpriseName',
    'enterprise_name',
    'supplierEnterpriseName',
    'project_name',
    'task_dt',
    'full_name',
    'phone',
    'medicalAlliance',
    'task_sum',
    'finish_sum',
    'nofinish',
    'pass',
    'nopass',
    'invalidCount',
    'finishRate'
  ], // 医学调研-汇总
  '8_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'medicalAlliance',
    'title',
    {
      label: '上传时间',
      prop: 'createDt'
    },
    'authStatus'
  ], // 医学病例收集-记录
  '8_1': [
    'index',
    'industryEnterpriseName',
    'enterprise_name',
    'supplierEnterpriseName',
    'project_name',
    'task_dt',
    'full_name',
    'phone',
    'medicalAlliance',
    'task_sum',
    'finish_sum',
    'nofinish',
    'pass',
    //todo ?
    'passing',
    'nopass',
    'invalidCount',
    'finishRate'
  ], // 医学病例收集-汇总
  '18_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'medicalAlliance',
    'title',
    {
      label: '上传时间',
      prop: 'createDt'
    },
    'authStatus'
  ], // 医学病例收集-记录
  '18_1': [
    'index',
    'industryEnterpriseName',
    'enterprise_name',
    'supplierEnterpriseName',
    'project_name',
    'task_dt',
    'full_name',
    'phone',
    'medicalAlliance',
    'task_sum',
    'finish_sum',
    'nofinish',
    'pass',
    'passing',
    'nopass',
    'invalidCount',
    'finishRate'
  ], // 医学病例收集-汇总
  '17_0': [
    'index',
    // 'expand_19',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'customerName',
    //todo 这里要分 1医院名称 2医疗机构名称 3药店名称
    'yymc',
    'yljgmc',
    'ydmc',
    'feedbackContent',
    'digitGradeName',
    // 信息转发记录, 信息反馈记录,
    'forward',
    'feedback',
    'auditStatus'
  ], // 数字拜访-记录
  '17_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ], // 数字拜访-汇总
  '19_0': [
    'expand_19',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'fullName',
    'phone',
    'zdje',
    'fileCount',
    'FolderName',
    //签约状态
    'signingStatus',
    // 'audit_status',
    //结算状态
    'finishStatus',
    //状态
    'auditStatus_19'
  ], // 协定服务-记录
  '19_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'assistantAlliance',
    {
      label: '计划任务量',
      prop: 'taskSum',
      formatter: () => {
        return '-';
      }
    },
    'finishSum',
    {
      label: '未完成量',
      prop: 'notFinish',
      formatter: () => {
        return '-';
      }
    },
    //todo  确认是不是要增加
    'passing',
    'passSum_19_1',
    'passSum_19_2',
    'notPassSum_19_1',
    'notPassSum_19_2',
    'invalidCount',
    {
      label: '任务完成率',
      prop: 'finishRate',
      formatter: () => {
        return '-';
      }
    }
  ], // 协定服务-汇总

  '20_0': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName_check',
    'phone',
    'taskCode',
    //提交时间
    'finishDt_20',
    //状态
    'auditStatus',
    'sceneCustom'
  ], // 可配置场景-记录
  '20_1': [
    'index',
    'industryEnterpriseName',
    'enterpriseName',
    'supplierEnterpriseName',
    'projectName',
    'taskDt',
    'fullName',
    'phone',
    'taskSum',
    'finishSum',
    'notFinish',
    'passSum',
    'passing',
    'notPassSum',
    'invalidCount',
    'finishRate'
  ] // 可配置场景-汇总
};
/**
 * @description: 搜索对应字段
 * @param {string, number}  type 项目类型_index(0|1) taxCollectionPattern 税筹结构 【本次新增字段】  1 汇总申报  2 委托代开（线下）  3 委托代发  4 运营基地  5 个体    9  工具
 * @return: searchFilter(copy)
 */
export default function(type, taxCollectionPattern) {
  let copy = map[type] ? [...map[type]] : null;
  // /* 所有场景要加入运营编码字段 在项目名称之后*/
  // if(copy){
  //   let index=copy.findIndex(r=>r==='projectName');
  //   if(index>0){
  //     copy.splice(index,0,'operateProjectNo')
  //   }
  // }
  if (taxCollectionPattern === 5) {
    copy.forEach((item, index) => {
      if (['fullName', 'full_name', 'agentName'].includes(item)) {
        copy[
          index
        ] = `${item}$$R_${taxCollectionPattern}=[{"label": "经营者","prop": "${item}"},"zooidEnterpriseName"]`;
      }
    });
  }
  if (taxCollectionPattern === 9) {
    copy.forEach((item, index) => {
      if (['fullName', 'full_name', 'agentName'].includes(item)) {
        copy[
          index
        ] = `${item}$$R_${taxCollectionPattern}=[{"label": "项目参与人","prop": "${item}"},"zooidEnterpriseName"]`;
      }
    });
  }
  if (copy) {
    let seat = $$Seat(copy, taxCollectionPattern);
    return createField(seat);
  }
  return null;
}
